import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SpinnerGap } from '@phosphor-icons/react';

const LoadingScreen = () => (
  <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
    <SpinnerGap size={48} className="animate-spin text-[#FACC15]" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user, loading, keyVerified } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!keyVerified) return <Navigate to="/" replace />;
  if (!user) return <Navigate to="/login" replace />;

  return children;
};

export const KeyGateRoute = ({ children }) => {
  const { keyVerified, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (keyVerified) return <Navigate to="/login" replace />;

  return children;
};

export const LoginRoute = ({ children }) => {
  const { user, loading, keyVerified } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!keyVerified) return <Navigate to="/" replace />;
  if (user) return <Navigate to="/dashboard" replace />;

  return children;
};

export const TwoFactorRoute = ({ children }) => {
  const { user, loading, keyVerified, pendingLogin } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!keyVerified) return <Navigate to="/" replace />;
  if (user) return <Navigate to="/dashboard" replace />;
  if (!pendingLogin) return <Navigate to="/login" replace />;

  return children;
};
